// themes/tealTheme.ts
import { createTheme } from "@mui/material/styles";

export const tealTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: "#9CC7C6", // teal pastel sáng chủ đạo
            paper: "rgba(255, 255, 255, 0.2)",
        },
        primary: {
            main: "#9CC7C6",   // teal pastel
            light: "#CFE7E6",  // nhạt hơn
            dark: "#3C8C94",   // đậm hơn để contrast
            contrastText: "#2E3A3A", // chữ đậm trên nền sáng
        },
        secondary: {
            main: "#D48C3B",        // accent cam đồng (contrast mạnh với teal)
            contrastText: "#FFFFFF" // chữ trắng trên nút cam
        },
        text: {
            primary: "#2E3A3A",   // chữ xám đậm, dễ đọc
            secondary: "#F9FAFA", // chữ sáng trên nền đậm
        },
    },

    shape: {
        borderRadius: 12,
    },

    typography: {
        fontFamily: '"Orbitron", sans-serif',
        button: {
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "0.9rem",
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#9CC7C6",
                    //   backgroundImage: `linear-gradient(rgba(9, 70, 98, 0.65), rgba(9, 70, 98, 0.95)), url('/assets/scam_education_bg.jpg')`,
                    //    backgroundImage: `linear-gradient(rgba(9, 70, 98, 0.65), rgb(4 55 78 / 95%)), url(/assets/scam_education_bg.jpg)`,
                    // backgroundImage: `linear-gradient(rgb(9 13 66 / 3%), rgb(4 55 78 / 82%)), url(/assets/scam_education_bg2.jpg)`,
                    backgroundImage: `linear-gradient(rgb(2 4 27 / 9%), rgb(4 55 78)), url(/assets/scam_education_bg2.jpg)`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",

                    "& .MuiSideBar": {
                        position: "relative",
                        borderRadius: "12px",
                        backgroundColor: "rgba(60, 140, 148, 0.75)", // teal đậm translucent
                        padding: "16px",
                        width: "100%",
                        maxWidth: "100%",
                        color: "#2E3A3A",
                        margin: "0 auto 20px",
                        "& .titleBox": {
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.75)",
                            borderRadius: "8px",
                            padding: "6px 16px",
                            width: "100%",
                            marginBottom: "16px",
                            "& .titleText": {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                color: "#3C8C94", // teal đậm để contrast
                                letterSpacing: "1px",
                                fontSize: "1rem",
                            }
                        }
                    },

                    "& .MuiMessage": {
                        padding: 24,
                        textAlign: "center",
                        borderRadius: "12px",
                        color: "white",
                        fontFamily: '"Orbitron", sans-serif',
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        letterSpacing: "1px",
                    },

                    "& .CenterButton": {
                        minWidth: "100px",
                        height: "160px",
                        borderRadius: "50%",
                        background: "radial-gradient(circle at 50% 50%, #e0f7f9, #9CC7C6)",
                        border: "2px solid #3C8C94",
                        boxShadow: "0 6px 18px rgba(60,140,148,.35)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.25s ease",
                        padding: 0,
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 12px 24px rgba(60,140,148,.45)",
                            "& .MuiSvgIcon-root": {
                                // color: "#3C8C94",
                                color: "#C9B98E",
                                filter: "drop-shadow(0 0 8px rgba(60,140,148,0.6))",
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "64px",
                            // color: "#2E3A3A",
                            color: "#C9B98E",
                            transition: "all 0.4s ease",
                        },
                    },
                },
                "*": {
                    boxSizing: "border-box",
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    "&.muiButtonIcon": {
                        fill: "#C9B98E"
                    },
                }
            }
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    backgroundColor: "rgb(211 219 224)", // cam accent
                    color: "rgb(24 71 92)",
                    "&:hover": {
                        backgroundColor: "rgb(24 71 92 / 69%)",
                        boxShadow: "0 0 12px rgb(24 71 92 / 69%)",
                        color:'white'
                    },
                    "&:active": {
                        transform: "scale(0.98)",
                    },
                    "&.active": {
                        backgroundColor: "rgb(24 71 92)", // fallback teal khi active
                        color: "white",
                        boxShadow: "0 0 12px rgb(24 71 92)",
                    }
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255,255,255,0.25)",
                    borderRadius: 12,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#9CC7C6",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#3C8C94",
                        boxShadow: "0 0 6px #3C8C94",
                    },
                    input: {
                        color: "#2E3A3A",
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                    borderRadius: 16,
                    backdropFilter: "blur(6px)",
                    boxShadow: "0 0 6px rgba(60, 140, 148, 0.3)",
                },
            },
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    color: "#2E3A3A",
                },
            },
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#76919e8f", // teal đậm → contrast rõ với nền
                    color: "#FFFFFF",
                }
            }
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.85)",
                    boxShadow: "0 0 16px rgba(60, 140, 148, 0.6)",
                    padding: "16px 24px",
                    color: "#2E3A3A",
                },
            },
        },
    },
});
